import Validation from "@irati/utils/validation"

const MAX_CHAR_LENGTH = 280

const schema = (intl) => Validation
  .string(intl.formatMessage({id: "platform.defaultValidation.required"}))
  .test("notJustSpaces", intl.formatMessage({id: "platform.defaultValidation.notJustSpaces"}),
    (value) => value && value.trim().length !== 0)
  .max(intl.formatNumber(MAX_CHAR_LENGTH),
    intl.formatMessage({id: "platform.defaultValidation.maxLength"}, {count: intl.formatNumber(MAX_CHAR_LENGTH)}))

export default schema
